import { useCallback } from 'react'
import { handleAgentQuestionConfirm } from '@/features/chat/agentQuestion/handleAgentQuestionConfirm.js'
import { useActiveAgentQuestion } from '@/features/chat/agentQuestion/useActiveAgentQuestion.js'

/** @param {object} m @param {{ handleSendMessage: Function }} handlers */
export function useAgentQuestionAction(m, handlers) {
  const { handleSendMessage } = handlers
  const activeAgentQuestion = useActiveAgentQuestion(m.activeMessages)

  const handleAgentQuestionConfirmChoice = useCallback(
    ({ optionId, freeText }) => {
      handleAgentQuestionConfirm({
        optionId,
        freeText,
        active: activeAgentQuestion,
        displayThreadId: m.displayThreadId,
        setMessagesByThreadId: m.setMessagesByThreadId,
        handleSendMessage,
      })
    },
    [activeAgentQuestion, m.displayThreadId, m.setMessagesByThreadId, handleSendMessage],
  )

  return {
    activeAgentQuestion: activeAgentQuestion?.question ?? null,
    handleAgentQuestionConfirm: handleAgentQuestionConfirmChoice,
  }
}
